import { Rule } from '@leprecoins/effector-forms';

export const onlyLatinRule: Rule<string> = {
	name: 'only-latin',
	validate: (value) => /^[a-zA-Z\s]*$/.test(value),
};
